exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menutop[data-v-0cad519e]{bottom:10px;right:10px;position:fixed;z-index:30;box-shadow:5px 0 13px 3px rgba(0,0,0,.1)}.botontop[data-v-0cad519e]{top:20px}.botontop1[data-v-0cad519e],.botontop[data-v-0cad519e]{right:20px;position:fixed;z-index:30;box-shadow:5px 0 13px 3px rgba(0,0,0,.1);border-radius:50%}.botontop1[data-v-0cad519e]{top:80px}.buttonadd[data-v-0cad519e]{box-shadow:5px 0 13px 3px rgba(0,0,0,.1)}.buttonedit[data-v-0cad519e]{margin-left:-10px}.buttondelete[data-v-0cad519e],.buttonedit[data-v-0cad519e]{position:absolute;z-index:20;margin-top:-5px;border-radius:50%;box-shadow:5px 0 13px 3px rgba(0,0,0,.1)}.buttondelete[data-v-0cad519e]{margin-left:28px}.buttonbloque[data-v-0cad519e]{box-shadow:5px 0 13px 3px rgba(0,0,0,.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0cad519e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/informes/Crea.vue
// module id = 556
// module chunks = 0